import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Bulb = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M8.842 18.166v-.65c0-.378-.217-.718-.54-.916a7.24 7.24 0 0 1-3.461-6.183A7.25 7.25 0 1 1 15.883 16.6c-.322.198-.538.538-.538.916v.65m-6.502 0v1.249a3.251 3.251 0 1 0 6.502 0v-1.249m-6.502 0h6.502'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='square'
      />
    ) : (
      <>
        <path
          d='M4.092 10.417a8 8 0 1 1 12.002 6.93v.069H8.09v-.07a8.01 8.01 0 0 1-4-6.93'
          fill='currentColor'
        />
        <path
          d='M8.092 18.916v.499a4.001 4.001 0 1 0 8.002 0v-.499z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
